/* unplugin-vue-components disabled */import { render } from "./UpdateDialog.vue?vue&type=template&id=3827dd22&scoped=true"
import script from "./UpdateDialog.vue?vue&type=script&lang=js"
export * from "./UpdateDialog.vue?vue&type=script&lang=js"

import "./UpdateDialog.vue?vue&type=style&index=0&id=3827dd22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3827dd22"]])

export default __exports__